/**
 * Het blokkadelog (MA-46): elke keer dat Funda de vanger tegenhield, met de
 * cijfers van dat moment. Dicht tot je het openklapt: het is iets om na een
 * blokkade in te kijken, niet om elke dag naar te staren. Na een paar regels
 * is te zien waar de grens ligt - na hoeveel pagina's in een uur, op welke
 * ronde van de dag - in plaats van te gokken.
 */
import { formatDatumTijd } from '@mamimap/shared';
import { ChevronDown, ChevronRight } from 'lucide-react';
import { useState } from 'react';
import { Melding } from '@/components/Melding';
import { useFundaBlokkades } from '@/lib/api/queries';
import { blokkadeCijfers, blokkadeGevolg, blokkadeSoortTekst } from './stand';

export function Blokkadelog() {
  const log = useFundaBlokkades();
  const [open, zetOpen] = useState(false);
  const regels = log.data ?? [];
  const Pijl = open ? ChevronDown : ChevronRight;

  return (
    <div className="flex flex-col gap-1.5">
      <button
        type="button"
        className="flex items-center gap-1 self-start text-[12.5px] text-ink-soft hover:text-ink"
        aria-expanded={open}
        onClick={() => zetOpen(!open)}
      >
        <Pijl className="h-3.5 w-3.5" aria-hidden="true" />
        Blokkadelog
        <span className="cijfers text-muted">({regels.length})</span>
      </button>

      {open && log.error ? <Melding fout={log.error} /> : null}

      {open && regels.length === 0 && !log.isLoading ? (
        <p className="text-[12px] text-muted">Nog geen blokkades.</p>
      ) : null}

      {open && regels.length > 0 ? (
        <div className="overflow-x-auto border border-line bg-surface-strong">
          <table className="tabel">
            <thead>
              <tr>
                <th>Wanneer</th>
                <th>Vanger</th>
                <th>Zoekopdracht</th>
                <th>Wat</th>
                <th>Cijfers</th>
                <th>Gevolg</th>
              </tr>
            </thead>
            <tbody>
              {regels.map((regel) => (
                <tr key={regel.id}>
                  <td className="cijfers whitespace-nowrap">{formatDatumTijd(regel.op)}</td>
                  <td>{regel.vanger ?? '–'}</td>
                  <td>{regel.zoekopdracht ?? '–'}</td>
                  <td className="whitespace-nowrap">{blokkadeSoortTekst(regel)}</td>
                  <td className="cijfers text-[12px]">{blokkadeCijfers(regel)}</td>
                  <td className="text-[12px] text-muted">{blokkadeGevolg(regel)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : null}
    </div>
  );
}
